"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const EditActionsGroupRow_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/UserPermissionsModal/ChangePermissionPopup/EditActionsGroupRow"));
const EditActionsGroupsTable = (props) => {
    const { rightsholderUser, editActionsGroups } = props;
    return (react_1.default.createElement("div", { className: 'actions-container' }, editActionsGroups.map((myUserGroup) => (react_1.default.createElement(EditActionsGroupRow_1.default, { myUserGroup: myUserGroup, rightsholderUser: rightsholderUser, key: myUserGroup.name })))));
};
exports.default = EditActionsGroupsTable;
